module.exports = __webpack_public_path__ + "img/case-02.34990dbe.png";